import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"step step-qq\"><span class=\"step-number\">1. </span><span>点击右上角“...”</span></div><div class=\"step step-qq\"><span class=\"step-number\">2. </span><span>选择“在浏览器打开”</span></div><div class=\"no-qq-browser\">请勿选择QQ浏览器，一定要在“系统默认浏览器”中下载并安装</div>", 3)
const _hoisted_6 = { class: "gif" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "hint-line",
      src: require('@/assets/images/line.png'),
      alt: "hint line"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        src: require('@/assets/images/qq.gif'),
        alt: "qq gif"
      }, null, 8, _hoisted_7)
    ])
  ]))
}